@file:OptIn(InternalResourceApi::class)

package advancedmpkeditor.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/advancedmpkeditor.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_058_969_056)
internal val Res.drawable.light_blue_concrete: DrawableResource by lazy {
      DrawableResource("drawable:light_blue_concrete", setOf(
        ResourceItem(setOf(), "${MD}drawable/light_blue_concrete.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_008_994_670)
internal val Res.drawable.light_blue_concrete_powder: DrawableResource by lazy {
      DrawableResource("drawable:light_blue_concrete_powder", setOf(
        ResourceItem(setOf(), "${MD}drawable/light_blue_concrete_powder.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-725_168_778)
internal val Res.drawable.light_blue_dye: DrawableResource by lazy {
      DrawableResource("drawable:light_blue_dye", setOf(
        ResourceItem(setOf(), "${MD}drawable/light_blue_dye.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(694_257_504)
internal val Res.drawable.light_blue_glazed_terracotta: DrawableResource by lazy {
      DrawableResource("drawable:light_blue_glazed_terracotta", setOf(
        ResourceItem(setOf(), "${MD}drawable/light_blue_glazed_terracotta.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(797_638_299)
internal val Res.drawable.light_blue_shulker_box: DrawableResource by lazy {
      DrawableResource("drawable:light_blue_shulker_box", setOf(
        ResourceItem(setOf(), "${MD}drawable/light_blue_shulker_box.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-235_940_956)
internal val Res.drawable.light_blue_stained_glass: DrawableResource by lazy {
      DrawableResource("drawable:light_blue_stained_glass", setOf(
        ResourceItem(setOf(), "${MD}drawable/light_blue_stained_glass.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_025_411_424)
internal val Res.drawable.light_blue_stained_glass_pane: DrawableResource by lazy {
      DrawableResource("drawable:light_blue_stained_glass_pane", setOf(
        ResourceItem(setOf(), "${MD}drawable/light_blue_stained_glass_pane.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_822_616_312)
internal val Res.drawable.light_blue_terracotta: DrawableResource by lazy {
      DrawableResource("drawable:light_blue_terracotta", setOf(
        ResourceItem(setOf(), "${MD}drawable/light_blue_terracotta.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(16_722_750)
internal val Res.drawable.light_blue_wool: DrawableResource by lazy {
      DrawableResource("drawable:light_blue_wool", setOf(
        ResourceItem(setOf(), "${MD}drawable/light_blue_wool.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_117_964_419)
internal val Res.drawable.light_gray_banner: DrawableResource by lazy {
      DrawableResource("drawable:light_gray_banner", setOf(
        ResourceItem(setOf(), "${MD}drawable/light_gray_banner.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_564_527_003)
internal val Res.drawable.light_gray_bed: DrawableResource by lazy {
      DrawableResource("drawable:light_gray_bed", setOf(
        ResourceItem(setOf(), "${MD}drawable/light_gray_bed.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_829_603_566)
internal val Res.drawable.light_gray_carpet: DrawableResource by lazy {
      DrawableResource("drawable:light_gray_carpet", setOf(
        ResourceItem(setOf(), "${MD}drawable/light_gray_carpet.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(837_024_365)
internal val Res.drawable.light_gray_concrete: DrawableResource by lazy {
      DrawableResource("drawable:light_gray_concrete", setOf(
        ResourceItem(setOf(), "${MD}drawable/light_gray_concrete.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_014_976_673)
internal val Res.drawable.light_gray_concrete_powder: DrawableResource by lazy {
      DrawableResource("drawable:light_gray_concrete_powder", setOf(
        ResourceItem(setOf(), "${MD}drawable/light_gray_concrete_powder.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-642_759_097)
internal val Res.drawable.light_gray_dye: DrawableResource by lazy {
      DrawableResource("drawable:light_gray_dye", setOf(
        ResourceItem(setOf(), "${MD}drawable/light_gray_dye.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_899_768_004)
internal val Res.drawable.light_gray_glazed_terracotta: DrawableResource by lazy {
      DrawableResource("drawable:light_gray_glazed_terracotta", setOf(
        ResourceItem(setOf(), "${MD}drawable/light_gray_glazed_terracotta.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_996_486_041)
internal val Res.drawable.light_gray_shulker_box: DrawableResource by lazy {
      DrawableResource("drawable:light_gray_shulker_box", setOf(
        ResourceItem(setOf(), "${MD}drawable/light_gray_shulker_box.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_450_622_852)
internal val Res.drawable.light_gray_stained_glass: DrawableResource by lazy {
      DrawableResource("drawable:light_gray_stained_glass", setOf(
        ResourceItem(setOf(), "${MD}drawable/light_gray_stained_glass.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_777_758_077)
internal val Res.drawable.light_gray_stained_glass_pane: DrawableResource by lazy {
      DrawableResource("drawable:light_gray_stained_glass_pane", setOf(
        ResourceItem(setOf(), "${MD}drawable/light_gray_stained_glass_pane.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_090_027_716)
internal val Res.drawable.light_gray_terracotta: DrawableResource by lazy {
      DrawableResource("drawable:light_gray_terracotta", setOf(
        ResourceItem(setOf(), "${MD}drawable/light_gray_terracotta.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(370_757_376)
internal val Res.drawable.light_gray_wool: DrawableResource by lazy {
      DrawableResource("drawable:light_gray_wool", setOf(
        ResourceItem(setOf(), "${MD}drawable/light_gray_wool.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-962_186_531)
internal val Res.drawable.light_weighted_pressure_plate: DrawableResource by lazy {
      DrawableResource("drawable:light_weighted_pressure_plate", setOf(
        ResourceItem(setOf(), "${MD}drawable/light_weighted_pressure_plate.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(797_070_205)
internal val Res.drawable.lilac: DrawableResource by lazy {
      DrawableResource("drawable:lilac", setOf(
        ResourceItem(setOf(), "${MD}drawable/lilac.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_048_352_863)
internal val Res.drawable.lily_of_the_valley: DrawableResource by lazy {
      DrawableResource("drawable:lily_of_the_valley", setOf(
        ResourceItem(setOf(), "${MD}drawable/lily_of_the_valley.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_244_766_284)
internal val Res.drawable.lily_pad: DrawableResource by lazy {
      DrawableResource("drawable:lily_pad", setOf(
        ResourceItem(setOf(), "${MD}drawable/lily_pad.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_192_265_612)
internal val Res.drawable.lime_banner: DrawableResource by lazy {
      DrawableResource("drawable:lime_banner", setOf(
        ResourceItem(setOf(), "${MD}drawable/lime_banner.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_593_717_616)
internal val Res.drawable.lime_bed: DrawableResource by lazy {
      DrawableResource("drawable:lime_bed", setOf(
        ResourceItem(setOf(), "${MD}drawable/lime_bed.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_398_931_353)
internal val Res.drawable.lime_carpet: DrawableResource by lazy {
      DrawableResource("drawable:lime_carpet", setOf(
        ResourceItem(setOf(), "${MD}drawable/lime_carpet.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_727_486_587)
internal val Res.drawable.lime_concrete: DrawableResource by lazy {
      DrawableResource("drawable:lime_concrete", setOf(
        ResourceItem(setOf(), "${MD}drawable/lime_concrete.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-125_297_460)
internal val Res.drawable.lime_concrete_powder: DrawableResource by lazy {
      DrawableResource("drawable:lime_concrete_powder", setOf(
        ResourceItem(setOf(), "${MD}drawable/lime_concrete_powder.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_339_135_742)
internal val Res.drawable.lime_dye: DrawableResource by lazy {
      DrawableResource("drawable:lime_dye", setOf(
        ResourceItem(setOf(), "${MD}drawable/lime_dye.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(257_122_567)
internal val Res.drawable.lime_glazed_terracotta: DrawableResource by lazy {
      DrawableResource("drawable:lime_glazed_terracotta", setOf(
        ResourceItem(setOf(), "${MD}drawable/lime_glazed_terracotta.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_042_490_716)
internal val Res.drawable.lime_shulker_box: DrawableResource by lazy {
      DrawableResource("drawable:lime_shulker_box", setOf(
        ResourceItem(setOf(), "${MD}drawable/lime_shulker_box.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_124_758_480)
internal val Res.drawable.lime_stained_glass: DrawableResource by lazy {
      DrawableResource("drawable:lime_stained_glass", setOf(
        ResourceItem(setOf(), "${MD}drawable/lime_stained_glass.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_278_494_323)
internal val Res.drawable.lime_stained_glass_pane: DrawableResource by lazy {
      DrawableResource("drawable:lime_stained_glass_pane", setOf(
        ResourceItem(setOf(), "${MD}drawable/lime_stained_glass_pane.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_057_478_159)
internal val Res.drawable.lime_terracotta: DrawableResource by lazy {
      DrawableResource("drawable:lime_terracotta", setOf(
        ResourceItem(setOf(), "${MD}drawable/lime_terracotta.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_077_896_215)
internal val Res.drawable.lime_wool: DrawableResource by lazy {
      DrawableResource("drawable:lime_wool", setOf(
        ResourceItem(setOf(), "${MD}drawable/lime_wool.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_328_443_322)
internal val Res.drawable.lingering_potion: DrawableResource by lazy {
      DrawableResource("drawable:lingering_potion", setOf(
        ResourceItem(setOf(), "${MD}drawable/lingering_potion.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_094_058_001)
internal val Res.drawable.llama_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:llama_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/llama_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_956_982_395)
internal val Res.drawable.lodestone: DrawableResource by lazy {
      DrawableResource("drawable:lodestone", setOf(
        ResourceItem(setOf(), "${MD}drawable/lodestone.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(949_411_956)
internal val Res.drawable.loom: DrawableResource by lazy {
      DrawableResource("drawable:loom", setOf(
        ResourceItem(setOf(), "${MD}drawable/loom.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(747_162_683)
internal val Res.drawable.magenta_banner: DrawableResource by lazy {
      DrawableResource("drawable:magenta_banner", setOf(
        ResourceItem(setOf(), "${MD}drawable/magenta_banner.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_475_085_530)
internal val Res.drawable.magenta_bed: DrawableResource by lazy {
      DrawableResource("drawable:magenta_bed", setOf(
        ResourceItem(setOf(), "${MD}drawable/magenta_bed.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_151_504_802)
internal val Res.drawable.magenta_carpet: DrawableResource by lazy {
      DrawableResource("drawable:magenta_carpet", setOf(
        ResourceItem(setOf(), "${MD}drawable/magenta_carpet.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-203_490_709)
internal val Res.drawable.magenta_concrete: DrawableResource by lazy {
      DrawableResource("drawable:magenta_concrete", setOf(
        ResourceItem(setOf(), "${MD}drawable/magenta_concrete.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_421_854_464)
internal val Res.drawable.magenta_concrete_powder: DrawableResource by lazy {
      DrawableResource("drawable:magenta_concrete_powder", setOf(
        ResourceItem(setOf(), "${MD}drawable/magenta_concrete_powder.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-173_174_637)
internal val Res.drawable.magenta_dye: DrawableResource by lazy {
      DrawableResource("drawable:magenta_dye", setOf(
        ResourceItem(setOf(), "${MD}drawable/magenta_dye.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(151_814_849)
internal val Res.drawable.magenta_glazed_terracotta: DrawableResource by lazy {
      DrawableResource("drawable:magenta_glazed_terracotta", setOf(
        ResourceItem(setOf(), "${MD}drawable/magenta_glazed_terracotta.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_438_262_149)
internal val Res.drawable.magenta_shulker_box: DrawableResource by lazy {
      DrawableResource("drawable:magenta_shulker_box", setOf(
        ResourceItem(setOf(), "${MD}drawable/magenta_shulker_box.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_162_457_407)
internal val Res.drawable.magenta_stained_glass: DrawableResource by lazy {
      DrawableResource("drawable:magenta_stained_glass", setOf(
        ResourceItem(setOf(), "${MD}drawable/magenta_stained_glass.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_713_893_255)
internal val Res.drawable.magenta_stained_glass_pane: DrawableResource by lazy {
      DrawableResource("drawable:magenta_stained_glass_pane", setOf(
        ResourceItem(setOf(), "${MD}drawable/magenta_stained_glass_pane.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(568_879_689)
internal val Res.drawable.magenta_terracotta: DrawableResource by lazy {
      DrawableResource("drawable:magenta_terracotta", setOf(
        ResourceItem(setOf(), "${MD}drawable/magenta_terracotta.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_964_503_177)
internal val Res.drawable.magenta_wool: DrawableResource by lazy {
      DrawableResource("drawable:magenta_wool", setOf(
        ResourceItem(setOf(), "${MD}drawable/magenta_wool.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-694_531_526)
internal val Res.drawable.magma_block: DrawableResource by lazy {
      DrawableResource("drawable:magma_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/magma_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(724_375_214)
internal val Res.drawable.magma_cream: DrawableResource by lazy {
      DrawableResource("drawable:magma_cream", setOf(
        ResourceItem(setOf(), "${MD}drawable/magma_cream.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_455_353_862)
internal val Res.drawable.magma_cube_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:magma_cube_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/magma_cube_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(39_868_243)
internal val Res.drawable.map: DrawableResource by lazy {
      DrawableResource("drawable:map", setOf(
        ResourceItem(setOf(), "${MD}drawable/map.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_732_430_720)
internal val Res.drawable.melon: DrawableResource by lazy {
      DrawableResource("drawable:melon", setOf(
        ResourceItem(setOf(), "${MD}drawable/melon.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(634_988_944)
internal val Res.drawable.melon_seeds: DrawableResource by lazy {
      DrawableResource("drawable:melon_seeds", setOf(
        ResourceItem(setOf(), "${MD}drawable/melon_seeds.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_008_525_914)
internal val Res.drawable.melon_slice: DrawableResource by lazy {
      DrawableResource("drawable:melon_slice", setOf(
        ResourceItem(setOf(), "${MD}drawable/melon_slice.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-133_481_469)
internal val Res.drawable.milk_bucket: DrawableResource by lazy {
      DrawableResource("drawable:milk_bucket", setOf(
        ResourceItem(setOf(), "${MD}drawable/milk_bucket.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_602_778_073)
internal val Res.drawable.minecart: DrawableResource by lazy {
      DrawableResource("drawable:minecart", setOf(
        ResourceItem(setOf(), "${MD}drawable/minecart.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(973_838_116)
internal val Res.drawable.missing_texture: DrawableResource by lazy {
      DrawableResource("drawable:missing_texture", setOf(
        ResourceItem(setOf(), "${MD}drawable/missing_texture.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(602_574_756)
internal val Res.drawable.mojang_banner_pattern: DrawableResource by lazy {
      DrawableResource("drawable:mojang_banner_pattern", setOf(
        ResourceItem(setOf(), "${MD}drawable/mojang_banner_pattern.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_253_484_803)
internal val Res.drawable.mooshroom_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:mooshroom_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/mooshroom_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-935_462_255)
internal val Res.drawable.mossy_cobblestone: DrawableResource by lazy {
      DrawableResource("drawable:mossy_cobblestone", setOf(
        ResourceItem(setOf(), "${MD}drawable/mossy_cobblestone.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-931_947_536)
internal val Res.drawable.mossy_cobblestone_slab: DrawableResource by lazy {
      DrawableResource("drawable:mossy_cobblestone_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/mossy_cobblestone_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_760_726_916)
internal val Res.drawable.mossy_cobblestone_stairs: DrawableResource by lazy {
      DrawableResource("drawable:mossy_cobblestone_stairs", setOf(
        ResourceItem(setOf(), "${MD}drawable/mossy_cobblestone_stairs.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_097_593_144)
internal val Res.drawable.mossy_cobblestone_wall: DrawableResource by lazy {
      DrawableResource("drawable:mossy_cobblestone_wall", setOf(
        ResourceItem(setOf(), "${MD}drawable/mossy_cobblestone_wall.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(793_584_162)
internal val Res.drawable.mossy_stone_brick_slab: DrawableResource by lazy {
      DrawableResource("drawable:mossy_stone_brick_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/mossy_stone_brick_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_000_030_750)
internal val Res.drawable.mossy_stone_brick_stairs: DrawableResource by lazy {
      DrawableResource("drawable:mossy_stone_brick_stairs", setOf(
        ResourceItem(setOf(), "${MD}drawable/mossy_stone_brick_stairs.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_834_902_103)
internal val Res.drawable.mossy_stone_brick_wall: DrawableResource by lazy {
      DrawableResource("drawable:mossy_stone_brick_wall", setOf(
        ResourceItem(setOf(), "${MD}drawable/mossy_stone_brick_wall.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-208_376_425)
internal val Res.drawable.mossy_stone_bricks: DrawableResource by lazy {
      DrawableResource("drawable:mossy_stone_bricks", setOf(
        ResourceItem(setOf(), "${MD}drawable/mossy_stone_bricks.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(423_552_318)
internal val Res.drawable.mule_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:mule_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/mule_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(503_286_932)
internal val Res.drawable.mushroom_stem: DrawableResource by lazy {
      DrawableResource("drawable:mushroom_stem", setOf(
        ResourceItem(setOf(), "${MD}drawable/mushroom_stem.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_421_221_234)
internal val Res.drawable.mushroom_stew: DrawableResource by lazy {
      DrawableResource("drawable:mushroom_stew", setOf(
        ResourceItem(setOf(), "${MD}drawable/mushroom_stew.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_891_257_527)
internal val Res.drawable.music_disc_11: DrawableResource by lazy {
      DrawableResource("drawable:music_disc_11", setOf(
        ResourceItem(setOf(), "${MD}drawable/music_disc_11.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_071_191_165)
internal val Res.drawable.music_disc_13: DrawableResource by lazy {
      DrawableResource("drawable:music_disc_13", setOf(
        ResourceItem(setOf(), "${MD}drawable/music_disc_13.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_014_067_903)
internal val Res.drawable.music_disc_blocks: DrawableResource by lazy {
      DrawableResource("drawable:music_disc_blocks", setOf(
        ResourceItem(setOf(), "${MD}drawable/music_disc_blocks.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_935_367_598)
internal val Res.drawable.music_disc_cat: DrawableResource by lazy {
      DrawableResource("drawable:music_disc_cat", setOf(
        ResourceItem(setOf(), "${MD}drawable/music_disc_cat.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_981_256_796)
internal val Res.drawable.music_disc_chirp: DrawableResource by lazy {
      DrawableResource("drawable:music_disc_chirp", setOf(
        ResourceItem(setOf(), "${MD}drawable/music_disc_chirp.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-935_871_314)
internal val Res.drawable.music_disc_far: DrawableResource by lazy {
      DrawableResource("drawable:music_disc_far", setOf(
        ResourceItem(setOf(), "${MD}drawable/music_disc_far.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_454_783_359)
internal val Res.drawable.music_disc_mall: DrawableResource by lazy {
      DrawableResource("drawable:music_disc_mall", setOf(
        ResourceItem(setOf(), "${MD}drawable/music_disc_mall.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_297_082_743)
internal val Res.drawable.music_disc_mellohi: DrawableResource by lazy {
      DrawableResource("drawable:music_disc_mellohi", setOf(
        ResourceItem(setOf(), "${MD}drawable/music_disc_mellohi.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_484_441_743)
internal val Res.drawable.music_disc_pigstep: DrawableResource by lazy {
      DrawableResource("drawable:music_disc_pigstep", setOf(
        ResourceItem(setOf(), "${MD}drawable/music_disc_pigstep.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_576_749_556)
internal val Res.drawable.music_disc_stal: DrawableResource by lazy {
      DrawableResource("drawable:music_disc_stal", setOf(
        ResourceItem(setOf(), "${MD}drawable/music_disc_stal.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-310_192_722)
internal val Res.drawable.music_disc_strad: DrawableResource by lazy {
      DrawableResource("drawable:music_disc_strad", setOf(
        ResourceItem(setOf(), "${MD}drawable/music_disc_strad.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_577_789_703)
internal val Res.drawable.music_disc_wait: DrawableResource by lazy {
      DrawableResource("drawable:music_disc_wait", setOf(
        ResourceItem(setOf(), "${MD}drawable/music_disc_wait.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_275_607_832)
internal val Res.drawable.music_disc_ward: DrawableResource by lazy {
      DrawableResource("drawable:music_disc_ward", setOf(
        ResourceItem(setOf(), "${MD}drawable/music_disc_ward.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_291_919_922)
internal val Res.drawable.mutton: DrawableResource by lazy {
      DrawableResource("drawable:mutton", setOf(
        ResourceItem(setOf(), "${MD}drawable/mutton.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_312_712_962)
internal val Res.drawable.mycelium: DrawableResource by lazy {
      DrawableResource("drawable:mycelium", setOf(
        ResourceItem(setOf(), "${MD}drawable/mycelium.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_307_697_215)
internal val Res.drawable.name_tag: DrawableResource by lazy {
      DrawableResource("drawable:name_tag", setOf(
        ResourceItem(setOf(), "${MD}drawable/name_tag.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_734_640_336)
internal val Res.drawable.nautilus_shell: DrawableResource by lazy {
      DrawableResource("drawable:nautilus_shell", setOf(
        ResourceItem(setOf(), "${MD}drawable/nautilus_shell.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-683_713_182)
internal val Res.drawable.nether_brick: DrawableResource by lazy {
      DrawableResource("drawable:nether_brick", setOf(
        ResourceItem(setOf(), "${MD}drawable/nether_brick.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_378_942_484)
internal val Res.drawable.nether_brick_fence: DrawableResource by lazy {
      DrawableResource("drawable:nether_brick_fence", setOf(
        ResourceItem(setOf(), "${MD}drawable/nether_brick_fence.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_174_271_097)
internal val Res.drawable.nether_brick_slab: DrawableResource by lazy {
      DrawableResource("drawable:nether_brick_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/nether_brick_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_611_120_334)
internal val Res.drawable.nether_brick_stairs: DrawableResource by lazy {
      DrawableResource("drawable:nether_brick_stairs", setOf(
        ResourceItem(setOf(), "${MD}drawable/nether_brick_stairs.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(497_360_133)
internal val Res.drawable.nether_brick_wall: DrawableResource by lazy {
      DrawableResource("drawable:nether_brick_wall", setOf(
        ResourceItem(setOf(), "${MD}drawable/nether_brick_wall.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_610_847_386)
internal val Res.drawable.nether_bricks: DrawableResource by lazy {
      DrawableResource("drawable:nether_bricks", setOf(
        ResourceItem(setOf(), "${MD}drawable/nether_bricks.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_029_833_118)
internal val Res.drawable.nether_gold_ore: DrawableResource by lazy {
      DrawableResource("drawable:nether_gold_ore", setOf(
        ResourceItem(setOf(), "${MD}drawable/nether_gold_ore.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable5Resources(map: MutableMap<String, DrawableResource>) {
  map.put("light_blue_concrete", Res.drawable.light_blue_concrete)
  map.put("light_blue_concrete_powder", Res.drawable.light_blue_concrete_powder)
  map.put("light_blue_dye", Res.drawable.light_blue_dye)
  map.put("light_blue_glazed_terracotta", Res.drawable.light_blue_glazed_terracotta)
  map.put("light_blue_shulker_box", Res.drawable.light_blue_shulker_box)
  map.put("light_blue_stained_glass", Res.drawable.light_blue_stained_glass)
  map.put("light_blue_stained_glass_pane", Res.drawable.light_blue_stained_glass_pane)
  map.put("light_blue_terracotta", Res.drawable.light_blue_terracotta)
  map.put("light_blue_wool", Res.drawable.light_blue_wool)
  map.put("light_gray_banner", Res.drawable.light_gray_banner)
  map.put("light_gray_bed", Res.drawable.light_gray_bed)
  map.put("light_gray_carpet", Res.drawable.light_gray_carpet)
  map.put("light_gray_concrete", Res.drawable.light_gray_concrete)
  map.put("light_gray_concrete_powder", Res.drawable.light_gray_concrete_powder)
  map.put("light_gray_dye", Res.drawable.light_gray_dye)
  map.put("light_gray_glazed_terracotta", Res.drawable.light_gray_glazed_terracotta)
  map.put("light_gray_shulker_box", Res.drawable.light_gray_shulker_box)
  map.put("light_gray_stained_glass", Res.drawable.light_gray_stained_glass)
  map.put("light_gray_stained_glass_pane", Res.drawable.light_gray_stained_glass_pane)
  map.put("light_gray_terracotta", Res.drawable.light_gray_terracotta)
  map.put("light_gray_wool", Res.drawable.light_gray_wool)
  map.put("light_weighted_pressure_plate", Res.drawable.light_weighted_pressure_plate)
  map.put("lilac", Res.drawable.lilac)
  map.put("lily_of_the_valley", Res.drawable.lily_of_the_valley)
  map.put("lily_pad", Res.drawable.lily_pad)
  map.put("lime_banner", Res.drawable.lime_banner)
  map.put("lime_bed", Res.drawable.lime_bed)
  map.put("lime_carpet", Res.drawable.lime_carpet)
  map.put("lime_concrete", Res.drawable.lime_concrete)
  map.put("lime_concrete_powder", Res.drawable.lime_concrete_powder)
  map.put("lime_dye", Res.drawable.lime_dye)
  map.put("lime_glazed_terracotta", Res.drawable.lime_glazed_terracotta)
  map.put("lime_shulker_box", Res.drawable.lime_shulker_box)
  map.put("lime_stained_glass", Res.drawable.lime_stained_glass)
  map.put("lime_stained_glass_pane", Res.drawable.lime_stained_glass_pane)
  map.put("lime_terracotta", Res.drawable.lime_terracotta)
  map.put("lime_wool", Res.drawable.lime_wool)
  map.put("lingering_potion", Res.drawable.lingering_potion)
  map.put("llama_spawn_egg", Res.drawable.llama_spawn_egg)
  map.put("lodestone", Res.drawable.lodestone)
  map.put("loom", Res.drawable.loom)
  map.put("magenta_banner", Res.drawable.magenta_banner)
  map.put("magenta_bed", Res.drawable.magenta_bed)
  map.put("magenta_carpet", Res.drawable.magenta_carpet)
  map.put("magenta_concrete", Res.drawable.magenta_concrete)
  map.put("magenta_concrete_powder", Res.drawable.magenta_concrete_powder)
  map.put("magenta_dye", Res.drawable.magenta_dye)
  map.put("magenta_glazed_terracotta", Res.drawable.magenta_glazed_terracotta)
  map.put("magenta_shulker_box", Res.drawable.magenta_shulker_box)
  map.put("magenta_stained_glass", Res.drawable.magenta_stained_glass)
  map.put("magenta_stained_glass_pane", Res.drawable.magenta_stained_glass_pane)
  map.put("magenta_terracotta", Res.drawable.magenta_terracotta)
  map.put("magenta_wool", Res.drawable.magenta_wool)
  map.put("magma_block", Res.drawable.magma_block)
  map.put("magma_cream", Res.drawable.magma_cream)
  map.put("magma_cube_spawn_egg", Res.drawable.magma_cube_spawn_egg)
  map.put("map", Res.drawable.map)
  map.put("melon", Res.drawable.melon)
  map.put("melon_seeds", Res.drawable.melon_seeds)
  map.put("melon_slice", Res.drawable.melon_slice)
  map.put("milk_bucket", Res.drawable.milk_bucket)
  map.put("minecart", Res.drawable.minecart)
  map.put("missing_texture", Res.drawable.missing_texture)
  map.put("mojang_banner_pattern", Res.drawable.mojang_banner_pattern)
  map.put("mooshroom_spawn_egg", Res.drawable.mooshroom_spawn_egg)
  map.put("mossy_cobblestone", Res.drawable.mossy_cobblestone)
  map.put("mossy_cobblestone_slab", Res.drawable.mossy_cobblestone_slab)
  map.put("mossy_cobblestone_stairs", Res.drawable.mossy_cobblestone_stairs)
  map.put("mossy_cobblestone_wall", Res.drawable.mossy_cobblestone_wall)
  map.put("mossy_stone_brick_slab", Res.drawable.mossy_stone_brick_slab)
  map.put("mossy_stone_brick_stairs", Res.drawable.mossy_stone_brick_stairs)
  map.put("mossy_stone_brick_wall", Res.drawable.mossy_stone_brick_wall)
  map.put("mossy_stone_bricks", Res.drawable.mossy_stone_bricks)
  map.put("mule_spawn_egg", Res.drawable.mule_spawn_egg)
  map.put("mushroom_stem", Res.drawable.mushroom_stem)
  map.put("mushroom_stew", Res.drawable.mushroom_stew)
  map.put("music_disc_11", Res.drawable.music_disc_11)
  map.put("music_disc_13", Res.drawable.music_disc_13)
  map.put("music_disc_blocks", Res.drawable.music_disc_blocks)
  map.put("music_disc_cat", Res.drawable.music_disc_cat)
  map.put("music_disc_chirp", Res.drawable.music_disc_chirp)
  map.put("music_disc_far", Res.drawable.music_disc_far)
  map.put("music_disc_mall", Res.drawable.music_disc_mall)
  map.put("music_disc_mellohi", Res.drawable.music_disc_mellohi)
  map.put("music_disc_pigstep", Res.drawable.music_disc_pigstep)
  map.put("music_disc_stal", Res.drawable.music_disc_stal)
  map.put("music_disc_strad", Res.drawable.music_disc_strad)
  map.put("music_disc_wait", Res.drawable.music_disc_wait)
  map.put("music_disc_ward", Res.drawable.music_disc_ward)
  map.put("mutton", Res.drawable.mutton)
  map.put("mycelium", Res.drawable.mycelium)
  map.put("name_tag", Res.drawable.name_tag)
  map.put("nautilus_shell", Res.drawable.nautilus_shell)
  map.put("nether_brick", Res.drawable.nether_brick)
  map.put("nether_brick_fence", Res.drawable.nether_brick_fence)
  map.put("nether_brick_slab", Res.drawable.nether_brick_slab)
  map.put("nether_brick_stairs", Res.drawable.nether_brick_stairs)
  map.put("nether_brick_wall", Res.drawable.nether_brick_wall)
  map.put("nether_bricks", Res.drawable.nether_bricks)
  map.put("nether_gold_ore", Res.drawable.nether_gold_ore)
}
